export const DEFAULT_SEASON_YEAR = new Date().getFullYear();
export const SEASON_AGNOSTIC = 'seasonAgnostic';
